__turbopack_context__.v({
  "image-wrapper": "styles-module__7tkgzW__image-wrapper",
  "restriction-image": "styles-module__7tkgzW__restriction-image",
  "text-wrapper": "styles-module__7tkgzW__text-wrapper",
});
